import React, { useMemo } from 'react';
import { Platform } from 'react-native';
import { PageLoaderElement as PageLoaderElementWeb } from './page-loader-element/PageLoaderElement.web';
import { PageLoaderElement as PageLoaderElementNative } from './page-loader-element/PageLoaderElement.native';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';

export const PageLoader = observer(({ showSentence = false }: { showSentence?: boolean }) => {
  const { i18n } = useStore();
  const sentences = useMemo(() => [i18n.t('loading:0'), i18n.t('loading:1'), i18n.t('loading:2')], [i18n]);

  return Platform.OS === 'web' ? (
    <PageLoaderElementWeb sentences={sentences} showSentence={showSentence} />
  ) : (
    <PageLoaderElementNative sentences={sentences} showSentence={showSentence} />
  );
});
